(function(angular, _) {
    /**
     * @ngdoc service
     * @name PathLevelFactory
     * @description Represents a level in a graph (could be a row or column based on how the graph is visualised).
     * The graph level is merely an abstraction helping to place a graph vertices in space or group vertices in a specific fashion.
     * @example
     *
     * Levels
     *        0   1   2
     *
     * Graph
     *          - C
     *         /
     *        A - B - E
     *        \
     *          - - - D
     *
     * Note that vertex D could have been placed on level 1, or any other level. This is left up to the implementer based on the requirements.
     */
    class PathLevelFactory {
        constructor(id, meta = {}) {
            this.uuid = _.uniqueId('level');
            this.id = id;
            this.meta = meta;
            this.vertices = [];
        }

        getMeta(path = null) {
            if (path) {
                return _.get(this.meta, path, null);
            }

            return this.meta;
        }

        setMeta(meta, value = null) {
            if (_.isPlainObject(meta)) {
                this.meta = meta;
            } else if (_.isUndefined(value)) {
                delete this.meta[meta];
            } else if (_.isString(meta)) {
                _.set(this.meta, meta, value);
            }

            return this;
        }

        getIdentifier() {
            return this.id;
        }

        getVertices() {
            return this.vertices;
        }

        addVertex(vertex) {
            const index = _.findIndex(this.vertices, (item) => item === vertex);

            if (index < 0) {
                this.vertices.push(vertex);
            }

            return this;
        }

        removeVertex(vertex) {
            const index = _.findIndex(this.vertices, (item) => item === vertex);

            if (index >= 0) {
                this.vertices.splice(index, 1);

                vertex.level = null;
            }

            return this;
        }

        getInboundEdges() {
            return _.flatMap(this.vertices, (vertex) => vertex.getInboundEdges());
        }

        getOutboundEdges() {
            return _.flatMap(this.vertices, (vertex) => vertex.getOutboundEdges());
        }

        toJSON() {
            return _.chain(this)
                .pick(['uuid', 'id', 'meta'])
                .cloneDeep()
                .assign({
                    vertices: _.map(this.vertices, (vertex) => vertex.toJSON())
                })
                .value();
        }

        destroy() {
            this.uuid = null;
            this.id = null;
            this.meta = null;
            this.vertices = null;
        }
    }

    angular.module('wtApp.dataService')
        .factory('PathLevelFactory', () => PathLevelFactory);
})(window.angular, window._);
